import React from 'react';

interface EmptySpaceInterface {
  size: string;
  desktopSize: string;
}

function EmptySpace({ size, desktopSize }: EmptySpaceInterface) {
  return <div className={`cl-spacer cl-spacer--${size} lg:cl-spacer--${desktopSize}`} />;
}

export default EmptySpace;
